import api from "../../../services/api";

const BASE_PATH = "/api/organizational-structure";

export const ORGANIZATIONAL_STRUCTURE_TYPES = {
  units: "units",
  departments: "departments",
  branches: "branches",
  categories: "procurement-categories",
};

export const getUnits = async (params = {}) => {
  const response = await api.get(
    `${BASE_PATH}/${ORGANIZATIONAL_STRUCTURE_TYPES.units}`,
    {
      params,
    },
  );
  return response.data;
};

export const getDepartments = async (params = {}) => {
  const response = await api.get(
    `${BASE_PATH}/${ORGANIZATIONAL_STRUCTURE_TYPES.departments}`,
    { params },
  );
  return response.data;
};

export const getBranches = async (params = {}) => {
  const response = await api.get(
    `${BASE_PATH}/${ORGANIZATIONAL_STRUCTURE_TYPES.branches}`,
    { params },
  );
  return response.data;
};

export const getCategories = async (params = {}) => {
  const response = await api.get(
    `${BASE_PATH}/${ORGANIZATIONAL_STRUCTURE_TYPES.categories}`,
    { params },
  );
  return response.data;
};

export const createItem = async (type, data) => {
  const response = await api.post(`${BASE_PATH}/${type}`, data);
  return response.data;
};

export const updateItem = async (type, id, data) => {
  const response = await api.put(`${BASE_PATH}/${type}/${id}`, data);
  return response.data;
};

export const deleteItem = async (type, id) => {
  const response = await api.delete(`${BASE_PATH}/${type}/${id}`);
  return response.data;
};

export default {
  getUnits,
  getDepartments,
  getBranches,
  getCategories,
  createItem,
  updateItem,
  deleteItem,
  ORGANIZATIONAL_STRUCTURE_TYPES,
};
